var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioConsole(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.504h-.75v-9h-1.5v9H18a1.501 1.501 0 00-1.5 1.5v1.5a1.502 1.502 0 001.5 1.5h.75v7.5h1.5v-7.5H21a1.502 1.502 0 001.5-1.5v-1.5a1.502 1.502 0 00-1.5-1.5zm0 3h-3v-1.5h3v1.5zM13.5 4.504h-.75v-3h-1.5v3h-.75a1.501 1.501 0 00-1.5 1.5v1.5a1.501 1.501 0 001.5 1.5h.75v13.5h1.5v-13.5h.75a1.501 1.501 0 001.5-1.5v-1.5a1.502 1.502 0 00-1.5-1.5zm0 3h-3v-1.5h3v1.5zM6 15.004h-.75v-13.5h-1.5v13.5H3a1.502 1.502 0 00-1.5 1.5v1.5a1.502 1.502 0 001.5 1.5h.75v3h1.5v-3H6a1.501 1.501 0 001.5-1.5v-1.5a1.502 1.502 0 00-1.5-1.5zm0 3H3v-1.5h3v1.5z",
    fill: "#45464F"
  })));
}
export default SvgAudioConsole;